import React from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import "./NavbarComponent.css";

const NavbarComponent = ({ scrollToSection }) => {
  return (
    <Navbar expand="lg" className="custom-navbar" sticky="top">
      <Container>
        <Navbar.Brand onClick={() => scrollToSection("home")} className="brand">
          <span className="brand-glow">Tathastu</span>
        </Navbar.Brand>
        {/* <Navbar.Toggle aria-controls="navbar-nav" /> */}<Navbar.Toggle aria-controls="navbar-nav" className="custom-toggler" />

        <Navbar.Collapse id="navbar-nav" className="justify-content-end">
          <Nav className="nav-links">
            <Nav.Link onClick={() => scrollToSection("home")}>Home</Nav.Link>
            <Nav.Link onClick={() => scrollToSection("services")}>Services</Nav.Link>
            <Nav.Link onClick={() => scrollToSection("about")}>About</Nav.Link>
            <Nav.Link onClick={() => scrollToSection("contact")}>Contact</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavbarComponent;
